import React from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import FreeShippingIcon from 'ggApp/shared/icons/freeShipping';
import { formatDateShort } from 'ggApp/utils/date';
import { PreorderProductFragment } from 'ggApp/types/graphql';

import { Container, FreeShipping, IconWrap, ShippingDates, TextWrap } from './styled';

type DeliveryBadgeProps = {
    className: string;
    deliveryEstimation?: {
        from: number;
        to: number;
    };
    withFreeShipping?: boolean;
    preorderProduct: PreorderProductFragment;
    tinyText?: boolean;
};

export const DeliveryBadge = ({
    className,
    withFreeShipping = false,
    deliveryEstimation,
    tinyText,
    preorderProduct,
}: DeliveryBadgeProps) => {
    let deliveryText;

    if (preorderProduct?.allocationDate) {
        deliveryText = (
            <ShippingDates>
                <Translator
                    tk="PREORDER_DELIVERY_TEXT"
                    withValues={{
                        startDate: formatDateShort(preorderProduct.allocationDate),
                    }}
                />
            </ShippingDates>
        );
    } else if (withFreeShipping) {
        deliveryText = (
            <FreeShipping>
                <Translator tk="SERVICE_TEXT_GRATIS" />
            </FreeShipping>
        );
    } else if (deliveryEstimation) {
        deliveryText = (
            <ShippingDates>
                <Translator
                    tk="BADGE_MESSAGE_DELIVERY_TIMES"
                    withValues={{
                        from: deliveryEstimation.from,
                        to: deliveryEstimation.to,
                    }}
                />
            </ShippingDates>
        );
    }

    return (
        <Container className={className}>
            {deliveryText !== undefined && (
                <IconWrap>
                    <FreeShippingIcon />
                </IconWrap>
            )}
            <TextWrap tinyText={tinyText}>{deliveryText}</TextWrap>
        </Container>
    );
};
